import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { FormGroup, Button } from 'react-bootstrap';
import Select from './../../../FormTemplate/Select';
import InputControl from './../../../FormTemplate/InputControl';

class RenderAccount extends React.Component {
   componentDidMount() {
      this.props.fields.push({
         account_id: '1300',
         amount: 0
      });
   }

   render() {
      const { fields, chartOfAccounts } = this.props;
      return (
         <div>
            <Button onClick={() => fields.push({
               account_id: '1300',
               amount: 0
            })} >Add Member</Button>

            {fields.map((item, index) => (
               <div key={index} >
                  <FormGroup>
                     <Field
                        name={`${item}.account_id`} component={Select} options={chartOfAccounts} label="" />
                  </FormGroup>
                  <FormGroup>
                     <Field
                        name={`${item}.amount`}
                        component={InputControl} type="number" />
                  </FormGroup>
                  {(index > 0) && <Button onClick={() => fields.remove(index)} >remove</Button>}
               </div>
            ))}
         </div>
      );
   }
}

RenderAccount.propTypes = {
   fields: PropTypes.object.isRequired,
   chartOfAccounts: PropTypes.array.isRequired
};

export  default RenderAccount;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/JournalEntries/Helper/RenderAccount.js
 **/